module.exports = __webpack_public_path__ + "static/img/page13.d66c106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page13.jpg
// module id = on7L
// module chunks = 0